import React, { useCallback } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { Tooltip } from "antd";

import LoadTable from "../../app/generic/loadTable";
import IconButton from "../../app/generic/iconButton";
import { deleteEntity } from "../../../modules/crudOperations";
import TableRowActions from "../../app/generic/tableRowActions";

function TemplateListTable({ push, templates, loadTemplates }) {
  const handleEditTemplate = useCallback(
    (c) => {
      push(`/consignment/${c.key}/edit`);
    },
    [push]
  );

  const handleNewConsignment = useCallback(
    (c) => {
      push(`/consignment/${c.key}/add`);
    },
    [push]
  );

  const intl = useIntl();
  const dropTemplate = useCallback(
    (consignmentId) => {
      deleteEntity(
        "consignment",
        consignmentId,
        intl.formatMessage({
          id: "consignment.template.name",
          defaultMessage: "Šablona",
        }),
        intl.formatMessage({
          id: "consignment.template.errorName",
          defaultMessage: "šablony",
        }),
        loadTemplates,
        true
      );
    },
    [intl, loadTemplates]
  );

  const columns = [
    {
      key: "insertionDateTime",
      title: intl.formatMessage({
        id: "consignment.template.insertionDateTime",
        defaultMessage: "Datum vytvoření",
      }),
      dataIndex: "insertionDateTime",
      sorter: (a, b) =>
        a.insertionDateTime
          ? a.insertionDateTime.localeCompare(b.insertionDateTime)
          : -1,
    },
    {
      key: "templateName",
      title: intl.formatMessage({
        id: "consignment.template.templateName",
        defaultMessage: "Název šablony",
      }),
      dataIndex: "templateName",
      sorter: (a, b) =>
        a.templateName ? a.templateName.localeCompare(b.templateName) : -1,
    },
    {
      key: "creator",
      title: intl.formatMessage({
        id: "consignment.template.creator",
        defaultMessage: "Tvůrce šablony",
      }),
      dataIndex: "creator",
      sorter: (a, b) =>
        a.user && a.user.username
          ? b.user && b.user.username
            ? a.user.username.localeCompare(b.user.username)
            : 1
          : -1,
      render: (user) => (
        <Tooltip title={`${user.firstname} ${user.lastname}`}>
          {user.username}
        </Tooltip>
      ),
    },
    {
      key: "actions",
      title: "",
      dataIndex: "",
      render: (c) => (
        <TableRowActions
          onEdit={() => handleEditTemplate(c)}
          onDelete={() => dropTemplate(c.key)}
        >
          <IconButton
            icon="plus"
            className="table-row-action-button"
            onClick={() => handleNewConsignment(c)}
            title={intl.formatMessage({
              id: "consignment.template.createNewFromOld",
              defaultMessage: "vytvořit novou zásilku na základě této šablony",
            })}
          />
        </TableRowActions>
      ),
    },
  ];

  return (
    <LoadTable
      what={intl.formatMessage({
        id: "consignment.template.what",
        defaultMessage: "šablon zásilek",
      })}
      columns={columns}
      values={templates}
      emptyText={intl.formatMessage({
        id: "consignment.template.noTemplates",
        defaultMessage: "žádné šablony zásilek",
      })}
      onLoadValues={loadTemplates}
      onRowDoubleClick={handleEditTemplate}
    />
  );
}

export default connect(null, { push })(TemplateListTable);
